export default class Component {
    #elements = {
        // pre-register root element
        root: document.body
    }

    constructor() {
        
    }

    /**
     * Add an HTML element to the element registry for later reference
     * 
     * @param {string} key 
     * @param {string} selector
     * @param {HTMLElement} rootElement
     * @returns {HTMLElement}
     */
    registerNewElement = (key, element) => {
        if (this.#elements[key]) {
            throw new Error(`Element "${key} is already registered`)
        }

        this.#elements[key] = element

        return element
    }

    /**
     * Retrieve a registered HTML element by key
     * 
     * @param {string} key 
     * @returns {HTMLElement}
     */
    getRegisteredElement = (key) => {
        const element = this.#elements[key]

        if (!element) {
            throw new Error(`Element "${key}" not registered`)
        }

        return element
    }

    /**
     * Get an HTML element by selector from a registered element or the document itself
     * 
     * @param {string} selector 
     * @param {HTMLElement|Document} rootElement
     * @returns {HTMLElement}
     */
    getElementBySelector = (selector, rootElement = document) => {
        const element = rootElement.querySelector(selector)

        if (!element) {
            throw new Error(`Can't find element with selector ${selector}`)
        }

        return element
    }

    /**
     * Get all HTML element by selector from a registered element or the document itself
     * 
     * @param {string} selector 
     * @param {HTMLElement|Document} rootElement
     * @returns {HTMLElement}
     */
    getElementsBySelector = (selector, rootElement = document) => {
        const elements = rootElement.querySelectorAll(selector)

        if (!elements) {
            throw new Error(`Can't find element with selector ${selector}`)
        }

        return elements
    }
}